import { authAPI } from '@/api'
import { useUserStore } from '@/stores/user.js'

export async function login(username, password)
{ 
  const response = await authAPI.post('/token/login/', {
    username: username,
    password: password
  })
  const userStore = useUserStore()
  // Access token from response body; refresh token is in HttpOnly cookie
  userStore.setToken(response.data.access)
}

export async function logout()
{ 
  const response = await authAPI.post('/token/logout/')
  const userStore = useUserStore()
  userStore.setToken("")
  userStore.clear()
  return response
}

export async function storeMeInfo()
{ 
  const response = await authAPI.get("/users/me/")
  const userStore = useUserStore()
  userStore.setData(response.data)
}

export async function storeMeProfile()
{ 
  const response = await authAPI.get("/users/me/")
  const userStore = useUserStore()
  userStore.setProfile(response.data)
}
